import {
  ProcessRTSBarcodeResponse,
  ReturnToStationDownloadResponse,
  ReturnToStationUIResponse,
} from "../../models/ApiResponse";
import { ProcessBarcodeRequest } from "../../models/requestModels/processBarcode";
import { ReturnToStationResponse } from "../../models/responseModels/returnToStationResponse";
import { axiosRequests } from "../axiosRequest";

export const ReturnToStationAgent = {
  getReturnToStationList: () =>
    axiosRequests.get<ReturnToStationUIResponse>(
      "/returnToStation/GetReturnToStationList"
    ),
  returnToStationCsvDownload: (
    returnToStationData: ReturnToStationResponse[]
  ) =>
    axiosRequests.post<ReturnToStationDownloadResponse>(
      "/returnToStation/DownloadCsv",
      returnToStationData
    ),
  returnToStationXlsxDownload: (
    returnToStationData: ReturnToStationResponse[]
  ) =>
    axiosRequests.postXlsx<Blob>(
      "/returnToStation/DownloadXlsx",
      returnToStationData
    ),
  processBarcodeForReceiving: (processBarcodeRequest: ProcessBarcodeRequest) =>
    axiosRequests.post<ProcessRTSBarcodeResponse>(
      "/returnToStation/ProcessBarcode",
      processBarcodeRequest
    ),
};
